/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetNursingHomeQueryResponse,
  GetNursingHomePathParams,
  GetNursingHome404,
} from '../types/GetNursingHome'

function getGetNursingHomeUrl({
  nursinghome_id,
}: {
  nursinghome_id: GetNursingHomePathParams['nursinghome_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/nursing_home/${nursinghome_id}/` as const,
  }
  return res
}

/**
 * @summary Get nursing home detail
 * {@link /api/v1/nursing_home/:nursinghome_id/}
 */
export async function getNursingHome(
  {
    nursinghome_id,
  }: { nursinghome_id: GetNursingHomePathParams['nursinghome_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetNursingHomeQueryResponse,
    ResponseErrorConfig<GetNursingHome404>,
    unknown
  >({
    method: 'GET',
    url: getGetNursingHomeUrl({ nursinghome_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
